<template>
  <div class="container">
  <div class="quyu">
    <div class="home-banner">
        <img class="banner-bg" src="@/assets/quyu.png" alt="">
        <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">区域经济分析与企业画像分析</p>
        </div>
    </div>
    <div class="project">
      <div class="proj-box">
        <div class="proj-cont">
          <div style="padding-bottom: 45px;"></div>
          <div class="common-title">
            场景说明 
          </div>
          <div class="proj-text">
            <p>税收经济分析处在全国税局系统的设立，一个重要的责任是使用税局大数据对当地经济的总体发展态势、对产业和企业的成长与产值和税收贡献进行分析与跟踪，从而为政府部门的区域经济规划、为产业发展和企业扶植政策的制定提供数字化依据。</p>
          </div>
          <div style="padding-bottom: 55px;"></div>
        </div>
      </div>
      <div class="proj-box" style="background:#F3F4F7">
        <div class="proj-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            业务需求点 
          </div>
          <div style="padding-bottom: 80px;"></div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              使用税局大数据从事地区经济成长分析和税源预测
            </div>
          </div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              分析行业和产业的发展趋势，尤其是本地重点产业的发展
            </div>
          </div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              识别潜力企业，从而能够精准扶植为上市导流
            </div>
          </div>
          <div style="padding-bottom: 50px;"></div>
        </div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 60px;"></div>
        <div class="common-title">
          解决方案 
        </div>
        <div class="proj-text" style="text-indent: 0;">
          <p>将部盾的DSS分析平台和金税三期产生的数据对接，产生了40页的分项分析报告</p>
        </div>
        <div class="box-list">
          <ul>
            <li>
              <div class="active-box">
                <div class="li-img"><img src="@/assets/quyujingji.png" alt=""></div>
                <div class="li-title">区域经济成长分析</div>
                <div class="li-text">
                  <p>地区和行业的经济活跃度分析</p>
                  <p>按照产值成长指标、利润指标、税收指标、税负指标进行全面的历史趋势、现状、和预测分析</p>
                  <p>分析侧重于比对分析（横向比对，趋势比对）和因素分析（成长阶段、政策、季节性等）</p>
                </div>
              </div>
            </li>
            <li class="li-active">
              <div class="active-box">
                <div class="li-img"><img src="@/assets/suiyuanfenxi.png" alt=""></div>
                <div class="li-title">税源分析与预测</div>
                <div class="li-text">
                  <p>税收与产值、利润的长期关联关系，税负率的趋势性变化 </p>
                  <p>按照税种、地域、行业、企业属性和企龄划分进行税源和贡献分析与预测</p>
                </div>
              </div>
            </li>
            <li>
              <div class="active-box">
                <div class="li-img"><img src="@/assets/huaxiang.png" alt=""></div>
                <div class="li-title">企业画像报告</div>
                <div class="li-text">
                  <p>按照行业、企业属性和企龄划分进行群体趋势分析</p>
                  <p>对企业总体表现和分项表现的评分、排序，以及以群体表现为参照画像分析</p>
                </div>
              </div>
            </li>
            
          </ul>
          <div style="padding-bottom: 80px;"></div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <div class="proj-box" style="background: #F3F4F7;">
      <div class="proj-cont">
        <div style="padding-bottom: 40px;"></div>
        <div class="proj-fangan">
          <img src="@/assets/组5.png" style="width: 1070px;height;595px;" alt="">
        </div>
        <div style="padding-bottom: 40px;"></div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 40px;"></div>
        <div class="proj-fangan">
          <img src="@/assets/图层10.png" style="width: 953px;height;529px;" alt="">
        </div>
        <div style="padding-bottom: 40px;"></div>
      </div>
    </div>
  </div>  
</div>
</template>

<script>
export default {
  name: "quyu",
  data() {
    return {
    };
  },
  methods: {
      
  },
  mounted() {

  },
}
</script>

<style scoped>
   
</style>